(function($) {$(document).ready(function() {

	$('.accord-block__title').on('click', toggleAccord);

	$('.accord-block.open-on-load')
		.addClass('open')
		.find('.accord-block__content')
		.css('display', 'block');

	function toggleAccord() {
		const $this = $(this);
		
		$this
			.closest('.accord-block')
			.toggleClass('open')
			.find('.accord-block__content')
			.slideToggle(300);
	}

});;jQueryBridget("flickity", Flickity, $);})(window.NEW_jquery);